module.exports = __webpack_public_path__ + "static/media/limitless-logo-solid-blue-s.c8ec29b5.webp";